var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-logo"},[(_vm.logo)?_c('b-img',{attrs:{"src":_vm.logo,"alt":(_vm.appNameSlug + "-logo"),"width":_vm.logoWidth}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.displayName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }